import React from "react";
import { Link } from "@tanstack/react-router";
import { 
  Users2, 
  Package, 
  Layers, 
  Box, 
  Settings, 
  Activity,
  ArrowRight
} from "lucide-react";

const masterModules = [
  {
    title: "Khách hàng",
    sub: "Đối tác & Công nợ",
    icon: Users2,
    href: "/customers",
    color: "text-blue-500",
    bgColor: "bg-blue-500/10"
  },
  {
    title: "Nhà Cung cấp",
    sub: "Vật tư & Gia công",
    icon: Users2,
    href: "/vendors",
    color: "text-indigo-500",
    bgColor: "bg-indigo-500/10"
  },
  {
    title: "Sản phẩm",
    sub: "Thành phẩm & Quy cách",
    icon: Package,
    href: "/products",
    color: "text-emerald-500",
    bgColor: "bg-emerald-500/10"
  },
  {
    title: "Loại sản phẩm",
    sub: "Phân loại nhóm bao bì",
    icon: Layers,
    href: "/product-types",
    color: "text-teal-500",
    bgColor: "bg-teal-500/10"
  },
  {
    title: "Danh mục vật tư",
    sub: "Nguyên vật liệu & Khổ",
    icon: Box,
    href: "/materials",
    color: "text-amber-500",
    bgColor: "bg-amber-500/10"
  },
  {
    title: "Loại vật tư",
    sub: "Giấy, Mực, Màng, Phụ liệu",
    icon: Layers,
    href: "/material-types",
    color: "text-orange-500",
    bgColor: "bg-orange-500/10"
  },
  {
    title: "Thiết bị SX",
    sub: "Máy in, Cán, Bế, Dán",
    icon: Settings,
    href: "/machines",
    color: "text-purple-500",
    bgColor: "bg-purple-500/10"
  },
  {
    title: "Quy trình SX",
    sub: "Công đoạn xưởng chuẩn",
    icon: Activity,
    href: "/processes",
    color: "text-rose-500",
    bgColor: "bg-rose-500/10"
  }
];

export default function MasterDashboard() {
  return (
    <div className="flex flex-col h-full bg-slate-50/50">
      <div className="flex-1 p-5 overflow-auto custom-scrollbar">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {masterModules.map((module) => {
            const Icon = module.icon;
            return (
              <Link
                key={module.href}
                to={module.href}
                className="group relative flex items-center justify-between rounded-xl border border-border bg-card p-4 transition-all hover:shadow-xs hover:border-primary/50"
              >
                <div className="flex items-center gap-3">
                  <div className={`inline-flex h-10 w-10 items-center justify-center rounded-lg ${module.bgColor}`}>
                    <Icon className={`h-5 w-5 ${module.color}`} />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-foreground">{module.title}</h3>
                    <p className="text-[11px] text-muted-foreground mt-0.5">
                      {module.sub}
                    </p>
                  </div>
                </div>
                
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all" />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
